const initCatalogDetailGift = {
  catalogGiftDetails: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
};

export const catalogGiftDetailReducer = (
  state = initCatalogDetailGift,
  action: any
) => {
  if (action.type === "SET_CATALOG_GIFT_DETAIL") {
    return {
      ...state,
      catalogGiftDetails: action.value,
    };
  }
  if (action.type === "SET_CATALOG_GIFT_DETAIL_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_CATALOG_GIFT_DETAIL_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_CATALOG_GIFT_DETAIL") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  return state;
};
